module.exports = __webpack_public_path__ + "media/images/svg/minus-icon-5d340f6d58ead73f6df0a1622c00920d.svg";